var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16V6.39478L11.2139 9.60331C11.696 9.89999 12.304 9.89999 12.7861 9.60331L18 6.39478V10.6288C18 10.8557 18.1753 11.0445 18.3977 11.0896V11.0896C18.6988 11.1505 19 10.9338 19 10.6266V6C19 5.44772 18.5523 5 18 5H6C5.44772 5 5 5.44772 5 6V16C5 16.5523 5.44772 17 6 17H12.6266C12.9338 17 13.1505 16.6988 13.0896 16.3977V16.3977C13.0445 16.1753 12.8557 16 12.6288 16H6ZM12.262 8.75165L16.7335 6H7.26652L11.738 8.75165C11.8987 8.85054 12.1013 8.85054 12.262 8.75165Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12C15.5645 12 14 13.5645 14 15.5C14 17.4355 15.5645 19 17.5 19C19.4355 19 21 17.4355 21 15.5C21 13.5645 19.4355 12 17.5 12ZM19.005 17.005C18.8685 17.1415 18.648 17.1415 18.5115 17.005L17.5 15.9935L16.4885 17.005C16.352 17.1415 16.1315 17.1415 15.995 17.005C15.8585 16.8685 15.8585 16.648 15.995 16.5115L17.0065 15.5L15.995 14.4885C15.8585 14.352 15.8585 14.1315 15.995 13.995C16.1315 13.8585 16.352 13.8585 16.4885 13.995L17.5 15.0065L18.5115 13.995C18.648 13.8585 18.8685 13.8585 19.005 13.995C19.1415 14.1315 19.1415 14.352 19.005 14.4885L17.9935 15.5L19.005 16.5115C19.138 16.6445 19.138 16.8685 19.005 17.005Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailError);
export default __webpack_public_path__ + "static/media/email-error.793c04e830dd40a9b71343b5639d0051.svg";
export { ForwardRef as ReactComponent };